var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleBlueDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm-75 235.31.24-.23a17.64 17.64 0 0 1 24.95 0l32.14 32.14v-129A17.64 17.64 0 0 1 256 120.58a17.64 17.64 0 0 1 17.64 17.64v129l32.14-32.14a17.64 17.64 0 0 1 25 0l.24.23a17.64 17.64 0 0 1 0 24.95l-62.5 62.49a17.63 17.63 0 0 1-24.94 0L181 260.26a17.66 17.66 0 0 1 0-24.95zm213 126a30.72 30.72 0 0 1-30.09 30.09H148.09A30.72 30.72 0 0 1 118 361.33v-46.9a17.64 17.64 0 0 1 17.64-17.64 17.64 17.64 0 0 1 17.64 17.64v41.71h205.44v-41.71a17.64 17.64 0 0 1 17.64-17.64A17.64 17.64 0 0 1 394 314.43z",
    "data-name": "Layer 2",
    fill: "#8fa8bb",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBlueDownload);
export default __webpack_public_path__ + "static/media/circle-blue-download.a6c7ab1ae02b7deb976d9f3a4d3f1917.svg";
export { ForwardRef as ReactComponent };